import { createFileRoute } from '@tanstack/react-router'

import { DashboardLayout } from '@/containers/dashboardLayout'

export const Route = createFileRoute('/_authenticated/account/_dashboard')({
  component: DashboardLayout,
})
